import { render, staticRenderFns } from "./ReceiveColli.vue?vue&type=template&id=366786fa&scoped=true"
import script from "./ReceiveColli.vue?vue&type=script&lang=js"
export * from "./ReceiveColli.vue?vue&type=script&lang=js"
import style0 from "./ReceiveColli.vue?vue&type=style&index=0&id=366786fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366786fa",
  null
  
)

export default component.exports